import React from 'react';
import OmLinearProgress from '../../../../components/ui/OmLinearProgress';
import OmCircularProgress from '../../../../components/ui/OmCircularProgress';

/**
 * LoadingSpinner Component
 * 
 * Displays loading state using OM Design System components.
 * Replaces legacy custom spinner with consistent OM loading indicators.
 * 
 * @param {Object} props - Component props
 * @param {string} [props.type] - Type of loading indicator ('spinner' or 'progress')
 * @param {string} [props.className] - Additional CSS classes
 * @param {string} [props.message] - Optional loading message
 */
const LoadingSpinner = ({ 
  type = 'spinner', 
  className = '', 
  message = 'Loading...' 
}) => {
  if (type === 'progress') {
    return (
      <div className={`w-full ${className}`}>
        <OmLinearProgress />
        {message && (
          <div className="text-sm text-gray-600 mt-2 text-center">
            {message}
          </div>
        )}
      </div>
    );
  }

  // Default spinner using OM CircularProgress
  return (
    <div className={`flex flex-col justify-center items-center h-64 ${className}`}>
      <OmCircularProgress
        indeterminate={true}
        size="large"
      />
      {message && message !== 'Loading...' && (
        <div className="mt-3 text-sm text-gray-600">
          {message}
        </div>
      )}
    </div>
  );
};

export default LoadingSpinner;